var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRecordVoiceOverHuman(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 51,
    viewBox: "0 0 51 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.3762 13.8511C25.3421 11.8581 22.66 9.24858 19.0291 9.85715C14.9379 10.5429 13.5742 9.57143 13.4037 9C12.3964 10.4471 11.2677 13.1768 13.4012 14.1988C12.5239 15.5256 12.0109 17.2165 12.0109 19.2231C12.0109 23.252 14.0791 26.7012 17.0109 28.1253V30.2722C12.7489 31.4578 8.95645 34.9253 6.11089 39.8871C5.56101 40.8459 6.2817 42 7.38701 42H33.1643C34.2696 42 34.9903 40.8459 34.4404 39.8871C31.4776 34.7207 27.4881 31.1744 23.0109 30.1372V28.1253C25.9427 26.7012 28.0109 23.252 28.0109 19.2231C28.0109 17.0368 27.4018 15.2252 26.3762 13.8511Z",
    fill: "#0A0A0A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.1484 26.9975C32.9334 24.49 32.9334 21.2388 31.1484 18.7313L34.7184 15.14C39.0109 19.815 39.0109 26.2963 34.7184 30.5888L31.1484 26.9975Z",
    fill: "#0A0A0A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M38.2884 11.4638L41.7522 8C50.0609 16.6063 50.0397 29.4837 41.7522 37.75L38.2884 34.2862C44.1747 27.5287 44.1747 17.8813 38.2884 11.4638Z",
    fill: "#0A0A0A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecordVoiceOverHuman);
export default __webpack_public_path__ + "static/media/RecordVoiceOverHuman.cd593beedd1029f857a44dabf1c6874e.svg";
export { ForwardRef as ReactComponent };